<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
        <div class="flex gap-2">
              <div class="relative">
                    <input type="text" [(ngModel)]="search" (input)="onSearchInput()" placeholder="Search.." class="pl-8" />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                        stroke="currentColor" class="absolute left-2 top-1/2 transform -translate-y-1/2 size-5">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                </div>
                <div>
                    <select (change)="onSelectStatus()" [(ngModel)]="status" id="inputStatus" class="min-w-40">
                        <!-- <option value="">Select Status</option> -->
                        <option [ngValue]="true">Active</option>
                        <option [ngValue]="false">Inactive</option>
                    </select>
                </div>
        </div>
        <div *ngIf="filteredDriverList && filteredDriverList.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (filteredDriverList.length != 50?
                (50
                -filteredDriverList.length) : 0) }} of {{totalResults }} entries
            </h1>
        </div>
        <div class="relative">
            <div class="flex flex-col sm:flex-row gap-2">
                <div>
                    <button routerLink="driver/add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_DRIVER])"
                        class="btn btn-secondary">
                        Add
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div
        class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">

        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th *ngIf="permissionService.hasPermission([userPermission.MANAGE_DRIVER])"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Name</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Contact No.</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        DOB</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        License Number</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Email</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Languages</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        City</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        State</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Created At</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Updated At</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Approve Status</th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                    *ngFor="let driver of filteredDriverList | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index">
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{i+1}}
                                    </td>
                                    <td *ngIf="permissionService.hasPermission([userPermission.MANAGE_DRIVER])"
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex items-center">
                                            <button [appToolTip]="'Detail'"
                                                class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400"
                                                (click)="openDriverModal(driver)">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="1.5" stroke="currentColor" class="size-5">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                </svg>
                                            </button>
                                            <div class="mx-2 h-6 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                                <div class="inline-flex relative">
                                                    <!-- *ngIf="!assign.isJClone" -->
                                                    <a [appToolTip]="'More Actions'" href="javascript:void(0)" (click)="showActionButtons(i)"
                                                        class="hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400">
                                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                                            class="w-5 h-5">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z" />
                                                        </svg>
                                                    </a>
                                                    <div (outsideClick)="closeActionMenu($event)" outside-click
                                                        *ngIf="selectedDropdownIndex === i && toggleActionButtons"
                                                        class="absolute left-4 z-20 my-4 w-64 origin-top-left rounded-md bg-white dark:bg-zinc-900 shadow-lg border border-zinc-950/10 hover:border-zinc-950/20 dark:border-white/10 dark:hover:border-white/20 focus:outline-none"
                                                        role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
                                                        <!-- (addAdditionalNote)="addAdditionalNote(assign, i)" -->
                                                        <app-onboarding-action-dropdown class="divide-y divide-zinc-950/10 dark:divide-white/10" 
                                                            [source]="'driver'" 
                                                            [entity]="driver"
                                                            [loading]="loading"
                                                            (edit)="openDriverEditModal(driver)"
                                                            (sync)="onSyncData(driver.id)"
                                                            (logs)="openLogModal(driver)"
                                                            (raiseTicket)="raiseTicket(driver)"
                                                        ></app-onboarding-action-dropdown>
                                                    </div>
                                                </div>
                                        </div>
                                    </td>
                                    <!-- Name -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{driver.displayName  | titlecase}}
                                    </td>
                                    <!-- Contact No. -->
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap"
                                        phoneNumberFormat [phoneNumber]="driver?.phoneNumber">
                                        {{driver.phoneNumber || ' N/A'}}</td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(driver.dob | date:'MM/DD/YYYY') || ' N/A'}}</td>
                                    <!-- License Number -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((driver?.driverLicense?.number) | titlecase) || 'N/A'}}</td>
                                    <!-- Employment Type -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{driver.email || ' N/A'}}</td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <div class="flex flex-wrap gap-1">
                                            <span *ngFor="let lang of getLanguagesList(driver.languageSpoken)" class="badge badge-primary">
                                                {{ (lang | titlecase)  || ' N/A' }}
                                            </span>
                                        </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((driver.address?.city) | titlecase) || ' N/A'}}</td> <!-- Created At -->
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((driver.address.state) | titlecase) || ' N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(driver.createdAt | date:'MM/DD/YYYY') || ' N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{(driver.updatedAt | date:'MM/DD/YYYY') || ' N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span
                                            [ngClass]="driver.isApproved ? 'badge-success':'badge-danger'">{{driver.isApproved
                                            ?
                                            'Approved' :
                                            'Unapproved' }}</span>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span
                                            [ngClass]="driver.isActive ? 'badge-success':'badge-danger'">{{driver.isActive
                                            ?
                                            'Active' : 'Inactive'}}</span>
                                    </td>

                                </tr>


                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>

<app-driver-verification-slideout *ngIf="driverModalObj" [driverObj]="driverModalObj" [scrollToField]="driverModalObj.documentType"
 [highlightStatus]="driverModalObj.documentStatus" (closeModal)="onDriverStatusUpdated($event)"></app-driver-verification-slideout>
<app-company-driver-edit-modal *ngIf="editDriverModalObj" [driver]="editDriverModalObj" (onSave)="onSaveDriver($event)"
    (onCloseModal)="onCloseDriverModal()"></app-company-driver-edit-modal>

<app-onboarding-logs-modal *ngIf="logObj" [source]="'driver'" [tripId]="logObj" (closeModal)="logObj = null"></app-onboarding-logs-modal>


